// services/everpro/everpro-order/createV3Body.ts — build body Create Shipment Order V3
// Struktur (swagger sandbox request.CreateOrderV3Request):
//   { client_order_no, order_reference_id, shipper/receiver: ContactInformationV3
//     { id (sub_district_id)*, name*, phone*, address*, address_note, email, latitude, longitude },
//     package: PackageInformationV3 { weight*, price*, type*, description* (≤150), count, dimension* },
//     shipment_type*, payment_type, pickup_time, rate_code*, signed_key*, shipment_price,
//     is_use_insurance, insurance_price, is_use_woodpacking, cod_price, shipping_note }
import type { CreateEverproOrderV3Params } from '../everpro-types';
import { normalizePhone } from './createBody.js';
import { toRFC3339WIB } from '../everpro-shipping';

export function buildCreateOrderV3Body(params: CreateEverproOrderV3Params): Record<string, any> {
  const dim = params.dimensionCm || { length: 10, width: 10, height: 10 };

  const body: Record<string, any> = {
    client_order_no: params.clientOrderNo,
    order_reference_id: params.clientOrderNo,
    shipper: {
      id: params.shipperSubDistrictId,
      name: params.shipperName,
      phone: normalizePhone(params.shipperPhone),
      address: params.shipperAddress,
      ...(params.shipperAddressNote ? { address_note: params.shipperAddressNote } : {}),
    },
    receiver: {
      id: params.receiverSubDistrictId,
      name: params.receiverName,
      phone: normalizePhone(params.receiverPhone),
      address: params.receiverAddress,
      ...(params.receiverAddressNote ? { address_note: params.receiverAddressNote } : {}),
    },
    package: {
      weight: params.weightKg,
      price: Math.round(params.packagePrice > 0 ? params.packagePrice : 1),
      type: 'REGULAR',
      description: (params.packageDesc || 'Paket').substring(0, 150),
      count: Math.max(1, Number(params.quantity) || 1),
      dimension: {
        height: Math.ceil(dim.height),
        length: Math.ceil(dim.length),
        width: Math.ceil(dim.width),
      },
    },
    shipment_type: params.shipmentType,
    rate_code: params.rateCode,
    signed_key: params.signedKey,
    shipment_price: params.shipmentPrice,
    is_use_insurance: false,
    insurance_price: 0,
    is_use_woodpacking: false,
  };

  if (params.isCOD) {
    body.payment_type = 'COD';
    body.cod_price = Math.round(params.codPrice || params.packagePrice || 1);
  }

  // Everpro Go backend WAJIB string RFC3339: "YYYY-MM-DDTHH:mm:ss+07:00".
  body.pickup_time = toRFC3339WIB(params.pickupTime || '');

  return body;
}
